module.exports = __webpack_public_path__ + "img/1.2.4业务分析师.d1bb69d8.png";